import { Box, Grid, Typography, styled } from "@mui/material";

import Table from "components/Table";
import WrapperAction from "./Component/WrapperAction";
import WrapperState from "./Component/WrapperState";

const headers = [
  {
    key: "name",
    align: "right",
    name: "نام صاحب حساب",
  },
  {
    key: "bank",
    align: "right",
    name: "نام بانک",
  },
  {
    key: "accountNo",
    align: "right",
    name: "شماره حساب",
  },
  {
    key: "cardNo",
    align: "right",
    name: "شماره کارت",
  },
  {
    key: "shebaNo",
    align: "right",
    name: "شماره شبا",
  },
  {
    key: "state",
    align: "right",
    name: "وضعیت",
  },
  {
    key: "actions",
    align: "right",
    name: "عملیات",
  },
];

function BankAccountsTable({ bankAccountList, handleEdit, handleDelete }) {
  const formattedDataList = bankAccountList?.map((data) => {
    return {
      name: (
        <Typography variant="h6" color="text.main">
          {data?.accountOwnerName}
        </Typography>
      ),
      bank: (
        <Typography variant="h6" color="text.main">
          {data?.bank}
        </Typography>
      ),
      accountNo: (
        <Typography variant="h6" color="text.main">
          {data?.accountNumber}
        </Typography>
      ),
      cardNo: (
        <Typography variant="h6" color="text.main">
          {data?.cardNumber}
        </Typography>
      ),
      shebaNo: (
        <Typography variant="h6" color="text.main">
          {data?.shabaNumber}
        </Typography>
      ),
      state: <WrapperState data={data} />,
      actions: (
        <WrapperAction
          data={data}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      ),
    };
  });

  return (
    <Grid item xs={12}>
      <BoxStyle>
        <Table headers={headers} items={formattedDataList} />
      </BoxStyle>
    </Grid>
  );
}

const BoxStyle = styled(Box)(({ theme }) => ({
  direction: "rtl",
  marginTop: theme.spacing(4),
}));

export default BankAccountsTable;
